import React from 'react';

interface ScrollDivProps {
  className?: string;
  children: React.ReactNode;
  onScrollBottom?(): void | Promise<void>;
  onScrollTop?(): void | Promise<void>;
  onScroll?(): void | Promise<void>;
}

let handlingScrollBottom = false;
let handlingScrollTop = false;
let handlingScroll = false;

export const ScrollDiv = (props: ScrollDivProps) => {
  const handleScroll = async (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    if (!handlingScroll) {
      handlingScroll = true;
      props.onScroll && await props.onScroll?.();
      handlingScroll = false;
    }
    const target = e.target as HTMLElement;
    const hitTop = target.scrollTop === 0;
    if (hitTop && !handlingScrollTop) {
      handlingScrollTop = true;
      props.onScrollBottom && await props.onScrollBottom?.();
      handlingScrollTop = false;
      return;
    }
    const hitBottom = target.scrollHeight - target.scrollTop - 0.1 * target.scrollHeight <= target.clientHeight;
    if (hitBottom && !handlingScrollBottom) {
      handlingScrollBottom = true;
      props.onScrollBottom && await props.onScrollBottom?.();
      handlingScrollBottom = false;
      return;
    }
  };
  return (
    <div className={`scrolldiv h-full overflow-auto ${props.className}`} onScroll={handleScroll}>
      {props.children}
    </div>
  );
};